import { doodBlockConfig, propertyValue } from './dood-block-config';
import {
  buildOrderedBlockDescriptor,
  type DescriptorFieldOrderItem,
} from './descriptor-field-order';
import type { IBlockDescriptor } from './descriptor';

export type OrderInvoicePreviewPayment = {
  id: string;
  amount: number;
  invoice_file_path: string;
  invoice_generation_status: 'GENERATED' | 'PENDING';
  invoice_number: string;
};

/**
 * Serializable preview VM for `OrderInvoiceBlockComponent`.
 * Kept in content-builder so dashboard + webapp share the same transport shape.
 */
export type OrderInvoiceBlockScenarioContent = {
  payments: readonly OrderInvoicePreviewPayment[];
};

export const ORDERINVOICEBLOCK_LEGACY_FIELD_ORDER = [
  "title",
  "download_label"
] as const satisfies readonly DescriptorFieldOrderItem[];

const {
  orderInvoiceBlockDescriptor: _generatedOrderInvoiceBlockDescriptor,
  orderInvoiceBlockBlocDefinition,
  orderInvoiceBlockDashboardLayout,
  orderInvoiceBlockConfig,
  orderInvoiceBlockResolveConfig,
  orderInvoiceBlockProperties,
  orderInvoiceBlockDefinitionSetupScenarios,
} = doodBlockConfig(
  {
    name: "Facture",
    componentType: 'OrderInvoiceBlockComponent',
    category: 'content',
    description: "Facture.",
    keywords: [],
    allowedIn: [
      { bloc: 'OrderStatusPageComponent', slot: '*' },
      { bloc: 'OrderDetailsPageComponent', slot: '*' },
    ],


    sharedFields: {}
  },

  () => ({
    title: propertyValue({
      type: 'text',
      value: '',
      options: {
        label: "pages.blocks.order-invoice.title.label",
      }
    }),
    download_label: propertyValue({
      type: 'text',
      value: '',
      options: {
        label: "pages.blocks.order-invoice.download-label.label",
      }
    })
  }),

  () => ({
    tabs: [
      {
        label: "pages.blocks.order-invoice.tab.content.label",
        fieldsets: [
          {
            legend: "pages.blocks.order-invoice.fieldset.texts.label",
            fields: ["title", "download_label"],
          },
        ],
      },
    ],
  })
);

export function orderInvoiceBlockDescriptor(): IBlockDescriptor;
export function orderInvoiceBlockDescriptor(
  fieldOrder: readonly DescriptorFieldOrderItem[],
): IBlockDescriptor;
export function orderInvoiceBlockDescriptor(
  fieldOrder?: readonly DescriptorFieldOrderItem[],
): IBlockDescriptor {
  if (fieldOrder === undefined) {
    return _generatedOrderInvoiceBlockDescriptor;
  }
  return buildOrderedBlockDescriptor(_generatedOrderInvoiceBlockDescriptor, orderInvoiceBlockProperties, fieldOrder);
}

export {
  orderInvoiceBlockBlocDefinition,
  orderInvoiceBlockDashboardLayout,
  orderInvoiceBlockProperties,
  orderInvoiceBlockConfig,
  orderInvoiceBlockResolveConfig,
  orderInvoiceBlockDefinitionSetupScenarios,
};

export type OrderInvoiceBlockConfig = typeof orderInvoiceBlockConfig;
